// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"f1f5c666","404":"1c45d877","521":"6ec62181","586":"9e13d174","643":"814dd4e3"}[chunkId] + ".chunk.js";
};